import { useRequest } from "ahooks";
import { getUserMe } from "@/services";
import TA from 'th-analytics';
import { taUtil } from "@/utils";

export const useMe = () => {
  return useRequest(getUserMe, {
    cacheKey: 'Me',
    cacheTime: -1,
    debounceWait: 300,
    onSuccess: (res) => {
      taUtil.setUserIdentifier(res ? res.email : '');
      TA.update({
        userIdentifier: res ? res.email : '',
      });
    },
  });
};
